import React from 'react';
import styled, {useTheme} from "styled-components";
import {ImageLane} from "../common";
import {MarginBox} from "../ui/styled";

const Wrapper = styled.div`
  width: 444px;
  overflow: hidden;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
`;

const HeaderTr = styled.tr`
  height: 64px;
  background-color: ${props => props.theme.color.white_200};
`;
const HeaderTh = styled.th`
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  position: relative;
  vertical-align: middle;
  color: ${props => props.theme.color.dark_100};
`;
const Table = styled.table`
  width: 100%;
`;


const BodyTr = styled.tr`
  height: 80px;
  cursor: pointer;

  ${props => {
    if (props.selected) {
      return `
  border-top: 1px solid ${props.theme.color.green_100} ;
  border-bottom: 1px solid ${props.theme.color.green_100} ;
          `;
    }
    return `
  border-top: 1px solid ${props.theme.color.default_border_color};
    `
  }}
  background-color: ${props => {
    let color = props.theme.color.site_main_color;
    if (props.selected) {
      color = props.theme.color.green_200
    }
    return color;
  }};

  &:hover {
    background-color: ${props => props.theme.color.green_200};
  }

`;
const BodyTd = styled.td`
  vertical-align: middle;
`;

const RankSpan = styled.span`
  font-weight: 700;
  font-size: 18px;
`;
const SmallRankSpan = styled.span`
  font-weight: 700;
  font-size: 8px;
`;

const TdBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SllTeamList = ({list, selectedTeamId,setSelectedTeamId}) => {
    return (
        <Wrapper>
            <Table>
                <colgroup>
                    <col width={'56px'}/>
                    <col width={'80px'}/>
                </colgroup>
                <thead>
                <HeaderTr>
                    <HeaderTh>순위</HeaderTh>
                    <HeaderTh>팀</HeaderTh>
                    <HeaderTh>
                        <ImageLane
                            color={'gray'}
                            lane={'top'}
                        />
                    </HeaderTh>
                    <HeaderTh><ImageLane
                        color={'gray'}
                        lane={'jungle'}
                    />
                    </HeaderTh>
                    <HeaderTh>
                        <ImageLane
                            color={'gray'}
                            lane={'middle'}
                        />
                    </HeaderTh>
                    <HeaderTh>
                        <ImageLane
                            color={'gray'}
                            lane={'bot'}
                        />
                    </HeaderTh>
                    <HeaderTh>
                        <ImageLane
                            color={'gray'}
                            lane={'support'}
                        />
                    </HeaderTh>
                </HeaderTr>
                </thead>
                <tbody>
                {list.map((data, index) => {
                    return (
                        <ContentTr key={data.team_name + "list"} data={data} rank={index + 1}
                                   selected={selectedTeamId} onClick={(value) => setSelectedTeamId(value)}/>
                    )
                })}
                </tbody>
            </Table>
        </Wrapper>
    );
};


const TeamSpan = styled.span`
  font-weight: 700;
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
  text-align: center;
`;
const WinLoseSpan = styled.span`
  margin-top: 2px;
  font-weight: 500;
  font-size: 10px;
  color: #B2B2C2
`;
const PlayerImage = styled.img`
  border-radius: 4px;
  object-fit: cover;
`;
const PlayerName = styled.div`
  width: 48px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
`;
const ContentTr = ({data, rank, selected, onClick}) => {
    const theme = useTheme();
    const nameUrl = (data) => {
        if (data?.status?.toLowerCase() === 'pro' && data.url_name) {
            return `/pro/${data.url_name}`
        } else if (data?.status?.toLowerCase() === 'streamer') {
            return `/strm/${data.name}`
        } else {
            console.log('error', data);
            return ""
        }
    }
    return (
        <BodyTr className={theme.color.theme} selected={selected === data.team_id} onClick={() => onClick(data.team_id)}>
            <BodyTd>
                <TdBox>
                    <RankSpan>
                        {rank}
                        <SmallRankSpan>
                            위
                        </SmallRankSpan>
                    </RankSpan>
                </TdBox>
            </BodyTd>
            <BodyTd>
                <TdBox>
                    <Column>
                        <TeamSpan>{data.team_name}</TeamSpan>
                        <WinLoseSpan>{data.win}승 {data.loss}패</WinLoseSpan>
                    </Column>
                </TdBox>
            </BodyTd>
            {[0,1,2,3,4].map((_, index) => {
                const item = data?.players?.[index];
                if(!item) {
                    return (
                        <BodyTd key={index}/>
                    )
                }
                return (
                    <BodyTd key={index}>
                        <Column>
                            <MarginBox margin={'0 0 4px 0'}>
                                <PlayerImage
                                    src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${item.status.toLowerCase()}/${item.status === 'pro' ? item.championship_name : item.name}.png`}
                                    width={48}
                                    height={48}
                                    alt={''}
                                    onError={(e) => e.target.src = '/images/sll/sll_empty_profile.svg'}
                                />
                            </MarginBox>
                            <PlayerName>
                                <TeamSpan>{item.name}</TeamSpan>
                            </PlayerName>
                        </Column>
                    </BodyTd>
                )
            })}

        </BodyTr>
    )
}

export default SllTeamList;